<template>
  <v-card
    color="grey darken-3"
    dark
  >
    <a
      class="a_link"
      href="http://byungin-song.com"
    >한국어</a>
    <a
      class="a_link"
      href="http://byungin-song.com/en"
    >English</a>

    <v-card-text>
      <avatar />
      <div class="text-sm-center mb-4 mt-3">
        <h1>Byungin<span class="light-blue--text text--lighten-3"> Song</span></h1>
        <span> Front-End Developer </span>
      </div>

      <sidebar-section :options="sections.info" />
      <sidebar-section :options="language !== 'en' ? sections.socials : sections.socials_en" />
      <sidebar-section :options="sections.hobbies">
        <template v-slot:item="{ item }">
          <v-chip>
            <v-avatar>
              <v-icon>
                {{ item.icon }}
              </v-icon>
            </v-avatar>
            {{ item.text }}
          </v-chip>
        </template>
      </sidebar-section>
      <sidebar-section :options="sections.languages">
        <template v-slot:items="{ items }">
          <v-container pa-0>
            <v-layout
              wrap
              class="text-xs-center"
            >
              <template v-for="(item, i) in items">
                <v-flex
                  :key="i"
                  md3
                  sm4
                  xs6
                >
                  <v-progress-circular
                    rotate="360"
                    size="65"
                    width="2"
                    :value="item.value"
                    color="white"
                    class="ma-2"
                  >
                    {{ item.text }}
                  </v-progress-circular>
                </v-flex>
              </template>
            </v-layout>
          </v-container>
        </template>
      </sidebar-section>
    </v-card-text>
  </v-card>
</template>

<script>
import Avatar from '@/views/dark-template/sidebar/Avatar'
import SidebarSection from '@/views/dark-template/sidebar/Section'
export default {
  name      : 'Sidebar',
  components: { SidebarSection, Avatar },
  data () {
    return {
      sections: {
        info: {
          title: 'INFO',
          items: [
            {
              name: 'Email',
              icon: 'mdi-email',
              text: 'byunginhb@gmail.com',
            },
            // {
            //   name: 'Website',
            //   icon: 'mdi-web',
            //   text: 'amirreza.in',
            // },
            {
              name: 'Birth Date',
              icon: 'mdi-cake-variant',
              text: 'Jun 18, 1987',
            },
            {
              name: 'Location',
              icon: 'mdi-map-marker',
              text: 'Seoul, South Korea',
            },
          ],
        },
        socials: {
          title: 'LINKS',
          items: [
            {
              icon: 'mdi-linkedin-box',
              text: 'linkedin.com/in/byungin-in-song',
              link: 'https://www.linkedin.com/in/byung-in-song-80566468/',
            },
            {
              icon: 'mdi-file-document-outline',
              text: '이력서 다운로드',
              link: 'https://firebasestorage.googleapis.com/v0/b/byungin-song.appspot.com/o/Byungin_Song_Resume_KR.pdf?alt=media&token=5484697d-03ec-42df-a010-2e3b43d1f444',
            },
          ],
        },
        socials_en: {
          title: 'LINKS',
          items: [
            {
              icon: 'mdi-linkedin-box',
              text: 'linkedin.com/in/byungin-in-song',
              link: 'https://www.linkedin.com/in/byung-in-song-80566468/',
            },
            {
              icon: 'mdi-file-document-outline',
              text: 'Resume Download',
              link: 'https://firebasestorage.googleapis.com/v0/b/byungin-song.appspot.com/o/Byungin_Song_Resume.pdf?alt=media&token=0cffa3f5-848e-4d1d-80ab-bda094de261c',
            },
          ],
        },
        hobbies: {
          title: 'HOBBIES',
          items: [
            {
              icon: 'mdi-biohazard',
              text: 'Challenges',
            },
            {
              icon: 'mdi-wallet-travel',
              text: 'Trip',
            },
            {
              icon: 'mdi-bike',
              text: 'Cycling',
            },
            {
              icon: 'mdi-image-filter-hdr',
              text: 'Nature',
            },
            {
              icon: 'mdi-music',
              text: 'Music',
            },
            {
              icon: 'mdi-karate',
              text: 'Sports',
            },
            {
              icon: 'mdi-golf',
              text: 'Golf',
            },
            {
              icon: 'mdi-gamepad-variant',
              text: 'Game',
            },
            {
              icon: 'mdi-movie',
              text: 'Movie',
            },
            {
              icon: 'mdi-snowman',
              text: 'Snow Board',
            },
          ],
        },
        // languages: {
        //   title: 'LANGUAGES',
        //   items: [
        //     {
        //       text : 'Korean',
        //       value: 100,
        //     },
        //     {
        //       text : 'English',
        //       value: 50,
        //     },
        //   ],
        // },
      },
    }
  },
  computed: {
    language () {
      return this.$route.params.lang
    },
  },
}
</script>

<style scoped>
  .sidebar {
    background: #2e2e2e;
  }
  .a_link {
    margin: 5px;
    color: white;
  }
</style>
